module.exports = __webpack_public_path__ + "media/app/apple-badge-es-ad023eb0.svg";